import { Link } from "react-router-dom";
import { ArrowRight, Boxes, Zap } from "lucide-react";
import { Reveal } from "@/components/Motion";

const SPOTS = [
  {
    slug: "3d-printing",
    name: "3D Printing",
    icon: Boxes,
    copy: "The newest addition to the workshop. Custom pieces built layer by layer — like these organization letters, printed in official colors with matching mini easels.",
    image: "/images/work-3d-letters.jpg",
    alt: "3D printed Omega Psi Phi and Delta Sigma Theta Greek letters in official colors, displayed on matching mini easels",
  },
  {
    slug: "laser-engraving",
    name: "Laser Engraving",
    icon: Zap,
    copy: "Names, logos, and designs etched right into the piece — from monogrammed bamboo boards to slate coasters that won't peel, crack, or wash out.",
    image: "/images/work-laser-coasters.jpg",
    alt: "Custom laser-engraved slate coasters with a Masonic square-and-compass design, beside a Skies The Limit Creations business card",
  },
];

export default function Spotlights() {
  return (
    <section className="mx-auto max-w-7xl px-5 py-20 sm:px-8 lg:py-28" data-testid="home-spotlight-section">
      <Reveal>
        <p className="eyebrow mb-4">Fresh from the workshop</p>
        <div className="flex flex-wrap items-end justify-between gap-6">
          <h2 className="max-w-xl font-display text-3xl font-bold tracking-tight text-white sm:text-4xl">
            Our two newest tools, already hard at work.
          </h2>
          <p className="max-w-sm text-sm leading-relaxed text-mist">
            Real pieces from real orders — photographed as they leave the shop. No stock photos, ever.
          </p>
        </div>
      </Reveal>

      <div className="mt-12 grid gap-6 md:grid-cols-2">
        {SPOTS.map((s, i) => (
          <Reveal key={s.slug} delay={i * 0.12}>
            <article className="card-panel group flex h-full flex-col overflow-hidden">
              <div className="overflow-hidden border-b border-white/10">
                <img
                  src={s.image}
                  alt={s.alt}
                  loading="lazy"
                  className="aspect-[4/3] w-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
              </div>
              <div className="flex flex-1 flex-col p-8">
                <h3 className="font-display text-2xl font-bold tracking-tight text-white">{s.name}</h3>
                <p className="mt-3 flex-1 text-sm leading-relaxed text-mist">{s.copy}</p>
                <Link
                  to={`/quote?s=${s.slug}`}
                  data-testid={`home-spotlight-quote-button-${s.slug}`}
                  className="mt-6 inline-flex items-center gap-2 text-sm font-semibold text-ember transition-colors duration-200 hover:text-ember-glow"
                >
                  Start a {s.name.toLowerCase()} quote
                  <ArrowRight className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-1" aria-hidden />
                </Link>
              </div>
            </article>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
